import { clearCsrfToken, setCsrfToken } from "@src/app/api/config/csrf";
import { getApiBaseUrl } from "@src/app/api/config/getApiBaseUrl";
import { IAuthResult } from "@src/interfaces/IAuthResult";
import axios from "axios";

const baseUrl = getApiBaseUrl();

const refreshClient = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

const csrfClient = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

interface ICsrfTokenResponse {
  csrfToken: string;
}

const bootstrapCsrfAfterRefresh = async (): Promise<void> => {
  try {
    const response = await csrfClient.get<ICsrfTokenResponse>("/security/csrf-token");
    setCsrfToken(response.data.csrfToken ?? null);
  } catch {
    clearCsrfToken();
  }
};

export const refreshAuthTokens = async (): Promise<boolean> => {
  const response = await refreshClient.post<IAuthResult>("/auth/refresh-token", {});
  await bootstrapCsrfAfterRefresh();
  return response.data.succeeded;
};
